module.exports = __webpack_public_path__ + "img/comp.5ac9d731.png";